import { BaseCustomElement } from "brut-js"

class DashboardRateMealButton extends BaseCustomElement {
  static tagName = "cc-dashboard-rate-meal-button"

  static observedAttributes = [
    "show-warnings",
    "form-action",
    "meal-name",
    "current-rating",
  ]


  #formAction = null
  #mealName = null
  #currentRating = null

  formActionChangedCallback({newValue}) {
    this.#formAction = newValue
  }

  mealNameChangedCallback({newValue}) {
    this.#mealName = newValue
  }

  currentRatingChangedCallback({newValue}) {
    this.#currentRating = newValue
  }

  #showRateMealDialog = (event) => {
    event.preventDefault()
    if (!this.#formAction) {
      this.logger.error("No form action set on the rate meal button component")
      return
    }
    const dialogId = event.currentTarget.getAttribute("aria-controls")
    if (!dialogId) {
      this.logger.error("No aria-controls attribute set on the rate meal button")
      return
    }
    const dialog = document.getElementById(dialogId)
    if (!dialog) {
      this.logger.error("Could not find dialog with id %s", dialogId)
      return
    }
    dialog.setAttribute("meal-name", this.#mealName)
    dialog.setAttribute("form-action", this.#formAction)
    dialog.setAttribute("current-rating", this.#currentRating)
    dialog.showModal()
  }

  update() {
    this.querySelectorAll("button[aria-haspopup=dialog]").forEach( (button) => {
      button.addEventListener("click", this.#showRateMealDialog)
    })
  }
}
export default DashboardRateMealButton
